const events = [
    {
        id: 1,
        title: "Monthly YSA Meeting",
        date: "Every 3rd Saterday at 1:00 PM",
        location: "Indianapolis Indiana Stake center",
        address: "900 East Stop 11 Road, INDIANAPOLIS, Indiana 46227-2547, United States, 39.650500, -86.142800",
        description: "Join us for our monthly YSA meeting with activities, discussions, and socializing.",
    },
    {
        id: 2,
        title: "Book of Mormon Study Group",
        date: "Every Wednesday at 8:30pm",
        location: "It's online via Zoom, meeting ID: 712 5869 3385, passcode: 3lbYsb",
        address: "N/A",
        description: "Study the Book of Mormon with the Missionaries and other YSA members.",
    },
    {
        id: 3,
        title: "Temple Trip",
        date: "December 13th 2025",
        location: "Indy Temple",
        address: "11565 Temple Dr. Carmel IN 46032",
        description: "Join us for Baptisms from 1pm-3pm and Endowment session @ 2pm & 2:30PM.",
    },
    {
        id: 4,
        title: "Caroling",
        date: "December 20th 2025",
        location: "Meet at Indianapolis Indiana Stake center for Carpooling",
        address: "900 East Stop 11 Road, INDIANAPOLIS, Indiana 46227-2547, United States, 39.650500, -86.142800",
        description: "Join us for Hot Coco and Caroling!",
    },
    {
        id: 5,
        title: "TEST Event",
        date: "Every 1st Saterday at 1:00 PM",
        location: "Indianapolis Indiana Stake center",
        address: "900 East Stop 11 Road, INDIANAPOLIS, Indiana 46227-2547, United States, 39.650500, -86.142800",
        description: "Join us for sadness."
    },
    {
        id: 6,
        title: "TEST Event",
        date: "Every 1st Saterday at 1:00 PM",
        location: "Indianapolis Indiana Stake center",
        address: "900 East Stop 11 Road, INDIANAPOLIS, Indiana 46227-2547, United States, 39.650500, -86.142800",
        description: "Join us for sadness."
    },
    {
        id: 7,
        title: "TEST Event",
        date: "Every 1st Saterday at 1:00 PM",
        location: "Indianapolis Indiana Stake center",
        address: "900 East Stop 11 Road, INDIANAPOLIS, Indiana 46227-2547, United States, 39.650500, -86.142800",
        description: "Join us for sadness."
    }
]

export default events;